import Vue from 'vue';
import App from '@/App.vue';
import vuetify from '@/plugins/vuetify';
import router from '@/router';
import i18n from '@/plugins/i18n'
import store from './store'

import { Auth } from '@aws-amplify/auth';

require('@/plugins/aws-amplify.js');
require('@/plugins/http-interceptor.js');

Vue.config.productionTip = false; // TODO-> check preprod/prod version to determine

new Vue({
  vuetify,
  router,
  i18n,
  store,
  render: h => h(App),
  beforeCreate () {
    Auth.currentSession().then(res => {
      this.$store.dispatch('loadCognitoUser', res.getIdToken().payload);
    }).catch(err => {
      console.log(err);
    });
  },
}).$mount('#app');
